import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { Nullable } from 'clickNgo/models/utils'
import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { IContact } from '../model/types'

import { mapContactFromContactAllData } from './mapping/mapContactFromContactAllData'

export const fetchContactRequestById = (
  contactId: string,
  options?: ICrudFetchOptions
): Promise<Nullable<IContact>> => {
  const crud = CrudStore.get(CrudStoreItem.ContactAllData, options?.cacheKey)
  const filters = [
    {
      field: 'ContactID',
      operator: Operator.EQUAL,
      value: contactId,
    },
  ]

  crud.setFilter({
    logic: Logic.AND,
    filters,
  })

  if (options?.sort) {
    crud.setSort(options.sort)
  }

  if (options?.paging) {
    crud.setPaging(options.paging)
  }

  return crud
    .fetch({
      skipHierarchyFilter: options?.skipHierarchyFilter,
      force: options?.isForce,
      skipTotal: options?.skipTotal,
    })
    .then((result) => {
      if (result && result.items[0]) {
        return mapContactFromContactAllData(result.items[0])
      }

      return null
    })
    .catch((e) => {
      Logger.error(e)
      return null
    })
}
